/**
 * Typed search params for the `/monthly-bills` route. The month filter lives in the URL so it is
 * deep-linkable AND compile-checked (the estimates/jobs `searchParams` pattern). TanStack Router
 * validates the raw URL params through `validateMonthlyBillsSearch` on every navigation.
 *
 * `?month=YYYY-MM` selects which month's occurrences the totals strip + the per-bill paid badges
 * reflect. The coarse endpoint (22-12) owns the scheduled sum + the paid lookup; the SPA only carries
 * the month flag (defaulting to the current month server-side when absent).
 */

export interface MonthlyBillsSearch {
  month?: string;
}

/** A YYYY-MM month string is the only valid filter value. */
function asMonth(value: unknown): string | undefined {
  return typeof value === 'string' && /^\d{4}-\d{2}$/.test(value) ? value : undefined;
}

/**
 * TanStack Router `validateSearch` for the monthly-bills list route. Keeps the month filter only when
 * it is a valid YYYY-MM so the canonical URL stays clean (`/monthly-bills` vs
 * `/monthly-bills?month=2026-06`).
 */
export function validateMonthlyBillsSearch(raw: Record<string, unknown>): MonthlyBillsSearch {
  const search: MonthlyBillsSearch = {};
  const month = asMonth(raw.month);
  if (month) search.month = month;
  return search;
}
